/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Default_Set_NameInputs */



/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Tags_Manager_Default_Set_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_default_set_name = /** @type {((inputs?: Tags_Manager_Default_Set_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Default_Set_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sans titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ohne Titel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Senza titolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Без названия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Intitulado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無題")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्षकहीन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem título")
	return /** @type {LocalizedString} */ ("Untitled")
});